(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.rouxWhyUsReady === 'true') return;
    section.dataset.rouxWhyUsReady = 'true';

    if (!section.classList.contains('roux-why-us--reveal')) {
      section.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        section.classList.add('is-visible');
        observer.unobserve(section);
      });
    }, { threshold: 0.12 });

    observer.observe(section);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-roux-why-us]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();